import React from 'react';
import Icon, { IconProps } from '../Icon';

const IconClasses: React.FC<IconProps> = ({ ...props }) => {
  const fill = props.fill;
  return (
    <Icon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.1199 18.1374H4.01632C2.9079 18.1374 2 17.2302 2 16.1212V4.99304C2 2.90753 2.68422 2 5.01428 2H16.7609V3.13887C15.7802 3.8013 15.8006 4.71984 16.3843 5.41674H15.2393C14.7993 4.63113 14.8749 3.73827 15.5674 3.02153C11.6542 3.02153 8.476 3.0263 4.56288 3.0263C2.7069 3.0263 2.75062 5.90095 4.59633 5.90095H7.26515C6.51388 6.32517 6.12012 7.18616 6.12012 8.40944L6.1199 18.1374ZM21.3687 21.9995V9.63813C20.4498 8.92881 20.2079 7.7855 21.3687 7.00134V5.86247H9.62254C7.29243 5.86247 6.60826 6.77 6.60826 8.8555V19.9837C6.60826 21.0926 7.51597 22 8.62458 22H21.3688L21.3687 21.9995ZM20.1973 9.76363C19.4029 8.88174 19.3354 7.75315 20.1754 6.88417C16.2622 6.88417 13.084 6.88895 9.17087 6.88895C7.31507 6.88895 7.35861 9.7636 9.20431 9.7636H20.1975L20.1973 9.76363Z"
        fill={fill}
      />
    </Icon>
  );
};

export default IconClasses;
